export const mobileVerifyEmailRouterPredicate = ({ currentUser, }) => {
    if (!currentUser) {
        return { isSuccess: false, navigateTo: '/' };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: true };
    }
    return { isSuccess: false, navigateTo: '/' };
};
export const mobileMainRoutePredicate = ({ currentUser }) => {
    if (Boolean(currentUser) && !currentUser?.emailVerified) {
        return { isSuccess: false, navigateTo: '/verify-email' };
    }
    return { isSuccess: true };
};
export const mobileRegisterRoutePredicate = ({ currentUser, }) => {
    if (!currentUser) {
        return { isSuccess: true };
    }
    if (!currentUser?.emailVerified) {
        return { isSuccess: false, navigateTo: '/verify-email' };
    }
    return {
        isSuccess: false,
        navigateTo: '/',
    };
};
